import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";

const SolutionSection = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);

  useEffect(() => {
    loadLanguageFile("SolutionSection", "home/home_SolutionSection_lang");
  }, [language]);

  const LANGUAGE = componentLanguageData.SolutionSection || { Main: {} };

  return (
    <>
      {/* Block 1 */}
      <div className="container-fluid bg-light mt-5 py-5">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-5 wow fadeIn" data-wow-delay="0.1s">
              <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">
                {LANGUAGE.Main.Content1}
              </div>
              <h1 className="mb-4">{LANGUAGE.Main.Content2}</h1>
              <p className="fs-5">{LANGUAGE.Main.Content3}</p>
              <p className="fs-5">{LANGUAGE.Main.Content4}</p>
              <p className="fs-5">{LANGUAGE.Main.Content5}</p>
              <p className="fs-5">{LANGUAGE.Main.Content6}</p>
              <p className="fs-5">{LANGUAGE.Main.Content7}</p>
              <a className="btn btn-primary rounded-pill px-4" href="/product_ai">
                {LANGUAGE.Main.Content8}
              </a>
            </div>
            {/* Cards */}
            <div className="col-lg-7">
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="row g-4">
                    <div className="col-12 wow fadeIn solution-fadeIn" data-wow-delay="0.1s">
                      <div className="solution-item d-flex flex-column justify-content-center text-center rounded">
                        <div className="solution-icon btn-square">
                          <i className="fa fa-robot fa-2x"></i>
                        </div>
                        <h5 className="mb-3">{LANGUAGE.Main.Content9}</h5>
                        <p>{LANGUAGE.Main.Content10}</p>
                      </div>
                    </div>
                    <div className="col-12 wow fadeIn" data-wow-delay="0.5s">
                      <div className="solution-item d-flex flex-column justify-content-center text-center rounded">
                        <div className="solution-icon btn-square">
                          <i className="fa fa-power-off fa-2x"></i>
                        </div>
                        <h5 className="mb-3">{LANGUAGE.Main.Content11}</h5>
                        <p>{LANGUAGE.Main.Content12}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 pt-md-4">
                  <div className="row g-4">
                    <div className="col-12 wow fadeIn" data-wow-delay="0.3s">
                      <div className="solution-item d-flex flex-column justify-content-center text-center rounded">
                        <div className="solution-icon btn-square">
                          <i className="fa fa-play fa-2x"></i>
                        </div>
                        <h5 className="mb-3">{LANGUAGE.Main.Content13}</h5>
                        <p>{LANGUAGE.Main.Content14}</p>
                      </div>
                    </div>
                    <div className="col-12 wow fadeIn" data-wow-delay="0.7s">
                      <div className="solution-item d-flex flex-column justify-content-center text-center rounded">
                        <div className="solution-icon btn-square">
                          <i className="fa fa-cogs fa-2x"></i>
                        </div>
                        <h5 className="mb-3">{LANGUAGE.Main.Content15}</h5>
                        <p>{LANGUAGE.Main.Content16}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Block 2 */}
      <div className="container-fluid bg-light mt-5 py-5">
        <div className="container py-5">
          <div className="row g-5 align-items-center">
            <div className="col-lg-5 wow fadeIn" data-wow-delay="0.1s">
              <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">
                {LANGUAGE.Main.Content17}
              </div>
              <h1 className="mb-4">{LANGUAGE.Main.Content18}</h1>
              <p className="fs-5">{LANGUAGE.Main.Content19}</p>
              <p className="fs-5">{LANGUAGE.Main.Content20}</p>
              <p className="fs-5">{LANGUAGE.Main.Content21}</p>
              <p className="fs-5">{LANGUAGE.Main.Content22}</p>
              <p className="fs-5">{LANGUAGE.Main.Content23}</p>
              <a className="btn btn-primary rounded-pill px-4" href="/product_lib">
                {LANGUAGE.Main.Content24}
              </a>
            </div>
            {/* Cards */}
            <div className="col-lg-7">
              <div className="row g-4">
                <div className="col-md-6">
                  <div className="row g-4">
                    <div className="col-12 wow fadeIn solution-fadeIn" data-wow-delay="0.1s">
                      <div className="solution-item d-flex flex-column justify-content-center text-center rounded">
                        <div className="solution-icon btn-square">
                          <i className="fa fa-book fa-2x"></i>
                        </div>
                        <h5 className="mb-3">{LANGUAGE.Main.Content25}</h5>
                        <p>{LANGUAGE.Main.Content26}</p>
                      </div>
                    </div>
                    <div className="col-12 wow fadeIn" data-wow-delay="0.5s">
                      <div className="solution-item d-flex flex-column justify-content-center text-center rounded">
                        <div className="solution-icon btn-square">
                          <i className="fa fa-exchange-alt fa-2x"></i>
                        </div>
                        <h5 className="mb-3">{LANGUAGE.Main.Content27}</h5>
                        <p>{LANGUAGE.Main.Content28}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 pt-md-4">
                  <div className="row g-4">
                    <div className="col-12 wow fadeIn" data-wow-delay="0.3s">
                      <div className="solution-item d-flex flex-column justify-content-center text-center rounded">
                        <div className="solution-icon btn-square">
                          <i className="fa fa-network-wired fa-2x"></i>
                        </div>
                        <h5 className="mb-3">{LANGUAGE.Main.Content29}</h5>
                        <p>{LANGUAGE.Main.Content30}</p>
                      </div>
                    </div>
                    <div className="col-12 wow fadeIn" data-wow-delay="0.7s">
                      <div className="solution-item d-flex flex-column justify-content-center text-center rounded">
                        <div className="solution-icon btn-square">
                          <i className="fa fa-chart-bar fa-2x"></i>
                        </div>
                        <h5 className="mb-3">{LANGUAGE.Main.Content31}</h5>
                        <p>{LANGUAGE.Main.Content32}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SolutionSection;
